const state = {
  updateAthleteInterval: {}
}

const mutations = {
  setInterval: function (state, payload) {
    if (!(Object.keys(state.updateAthleteInterval).length === 0 && state.updateAthleteInterval.constructor === Object)) {
      clearInterval(state.updateAthleteInterval)
    }
    state.updateAthleteInterval = payload
  }
}

const actions = {
  setIntervalAsync: function (context, raceId) {
    const interval = setInterval(function () {
        context.dispatch('loadRaceAthletes', {raceId: raceId, update: true})
        context.dispatch('loadRaceAthlete', context.rootState.athletes.athlete.id)
      },
    30000)
    context.commit('setInterval', interval)
  }
}

const getters = {
  updateAthleteInterval: state => {
    return state.updateAthleteInterval
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/interval.js